import { typography } from 'styles/typography'

const themeStyles = colors => ({
  modal: {
    maxWidth: 420
  },
  header: {
    ...typography.header1,
    color: colors.lightGray,
    display: 'flex',
    margin: 0,
    gap: '1em',
    alignItems: 'center',
    borderBottomColor: colors.silverGray,
    backgroundColor: colors.white,
    justifyContent: 'space-between'
  },
  closeIcon: {
    cursor: 'pointer'
  },
  content: {
    ...typography.fontMedium,
    padding: '1.5em',
    color: colors.approxBlack,
    backgroundColor: colors.white,
    borderRadius: 16
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '0.7em'
  },
  title: {
    ...typography.header1,
    textAlign: 'center',
    color: colors.approxBlack,
    margin: 0
  },
  errorTitle: {
    ...typography.header1,
    textAlign: 'center',
    color: colors.secondary,
    margin: 0
  },
  redirectTitle: {
    ...typography.header1,
    textAlign: 'center',
    color: colors.approxBlack,
    margin: 0,
    maxWidth: '85%'
  },
  message: {
    ...typography.fontMedium,
    fontSize: '1.3em',
    textAlign: 'center',
    color: colors.black,
    margin: '0'
  },
  errorMessage: {
    ...typography.fontMedium,
    fontSize: '1.3em',
    textAlign: 'center',
    color: colors.secondary,
    margin: '0'
  },
  actions: {
    display: 'flex',
    flexDirection: 'row',
    gap: '1em',
    justifyContent: 'center',
    padding: '0.5em',
    background: colors.white,
    flexWrap: 'wrap'
  },
  button: {
    flex: 1,
    margin: 0,
    cursor: 'pointer',
    color: colors.white,
    backgroundColor: colors.primary,
    borderRadius: '2em',
    minWidth: '7em'
  },
  loadingText: {
    ...typography.fontSemiBold,
    fontSize: '1.3em',
    color: colors.approxBlack,
    margin: 0
  },
  messageBlock: {
    ...typography.fontMedium,
    fontSize: '1.3em',
    textAlign: 'center',
    color: colors.approxBlack,
    lineHeight: 1.4
  },
  learnMore: {
    color: colors.primary,
    textDecoration: 'none'
  },
  continueButton: {
    width: '100%',
    minWidth: 100,
    marginBottom: 0,
    backgroundColor: colors.primary,
    color: colors.white,
    textTransform: 'uppercase',
    borderRadius: '2em',
    border: 'none',
    cursor: 'pointer',
    padding: '0.7em 1em',
    fontWeight: 600,
    letterSpacing: '0.7px',
    outline: 'none',
    transition: 'none'
  },
  cancelButton: {
    width: '100%',
    minWidth: 100,
    backgroundColor: colors.secondaryGray,
    color: colors.white,
    textTransform: 'uppercase',
    borderRadius: '2em',
    border: 'none',
    cursor: 'pointer',
    padding: '0.7em 1em',
    fontWeight: 600,
    letterSpacing: '0.7px',
    outline: 'none',
    transition: 'none'
  },
  redirectActions: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    gap: '12px',
    justifyContent: 'center',
    padding: '0.5em 0',
    background: colors.white,
    width: '100%'
  },
  doNotShowRow: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '0.5em',
    marginTop: '1.5em',
    cursor: 'pointer'
  },
  doNotShowLabel: {
    ...typography.font,
    fontSize: '0.95em',
    color: colors.approxBlack,
    cursor: 'pointer'
  }
})

export default themeStyles
